/* Newsroom */
(function () {
    var FOCUS_KEY = 'newsroomFilterFocus';

    function submitClean(form, focusId) {
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
            if (value !== '') {
                params.append(key, value);
            }
        });
        try {
            if (focusId) {
                sessionStorage.setItem(FOCUS_KEY, focusId);
            }
        } catch (err) {}
        var query = params.toString();
        window.location.href = form.getAttribute('action') + (query ? '?' + query : '');
    }

    document.querySelectorAll('.newsroom-filters').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            submitClean(form, null);
        });
        form.addEventListener('change', function (e) {
            if (e.target.matches('select')) {
                submitClean(form, e.target.id);
            }
        });
        form.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && e.target.matches('select')) {
                e.preventDefault();
                submitClean(form, e.target.id);
            }
        });
    });

    document.querySelectorAll('.media-assets-filters').forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            submitClean(form, null);
        });
        form.addEventListener('change', function (e) {
            if (e.target.matches('input[type="checkbox"]')) {
                submitClean(form, e.target.id);
            }
        });
        form.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && e.target.matches('input[type="checkbox"]')) {
                e.preventDefault();
                e.target.checked = !e.target.checked;
                submitClean(form, e.target.id);
            }
        });
    });

    try {
        var restoreId = sessionStorage.getItem(FOCUS_KEY);
        if (restoreId) {
            sessionStorage.removeItem(FOCUS_KEY);
            var restoreEl = document.getElementById(restoreId);
            if (restoreEl) {
                restoreEl.focus();
            }
        }
    } catch (err) {}

    var initCarousel = function () {
        var carousel = document.querySelector('[data-newsroom-carousel]');
        if (!carousel || !window.jQuery || typeof window.jQuery.fn.slick !== 'function' || carousel.classList.contains('slick-initialized')) {
            return;
        }
        var controls = document.createElement('div');
        controls.className = 'newsroom-carousel__controls';
        carousel.parentNode.appendChild(controls);
        window.jQuery(carousel).slick({
            dots: true,
            arrows: true,
            appendArrows: controls,
            appendDots: controls,
            infinite: false,
            prevArrow: '<button type="button" class="newsroom-carousel__arrow newsroom-carousel__arrow--prev"><span class="visually-hidden">Previous image</span><span class="material-icons" aria-hidden="true">arrow_back</span></button>',
            nextArrow: '<button type="button" class="newsroom-carousel__arrow newsroom-carousel__arrow--next"><span class="visually-hidden">Next image</span><span class="material-icons" aria-hidden="true">arrow_forward</span></button>'
        });
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarousel);
    } else {
        initCarousel();
    }
    window.addEventListener('load', initCarousel);
})();
